import React from 'react'

import AddBrandForm from '../../modules/Brand/components/AddBrandForm'
export default function AddBrandPage() {
  return (
    <AddBrandForm/>  )
}
